import { useSearchParams } from 'react-router-dom';

/**
 * URL-backed single-value filter state. Reads and writes one query parameter
 * (e.g. `?search=foo`) so a free-word search is shareable and survives
 * refreshes. An empty value removes the parameter from the URL.
 *
 * @param param - The query-parameter name to read/write.
 */
export const useUrlValue = (
  param: string,
): [string, (value: string) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = searchParams.get(param) ?? '';

  const setValue = (next: string) => {
    setSearchParams(
      prev => {
        const nextParams = new URLSearchParams(prev);
        if (next) {
          nextParams.set(param, next);
        } else {
          nextParams.delete(param);
        }
        return nextParams;
      },
      { replace: true },
    );
  };

  return [value, setValue];
};
